import { useState } from "react";
import SideBar from "./Layout/SideBar";
import Project from "./pages/Project";
// import Testimonials from "./pages/Testimonials";
// import About from "./pages/About";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Skills from "./pages/Skills";
import NoPage from "./pages/NoPage";
import Header from "./Layout/Header";

const App = () => {
  const [headerStyle, setHheaderStyl] = useState("");

  const homeStyleHandler = () => {
    setHheaderStyl("p-4 text-2xl md:pt-0 md:p-8 md:text-4xl");
  };
  const otherStyleHandler = () => {
    setHheaderStyl("invisible");
  };

  return (
    // <main className="relative min-h-[calc(100vh)] mx-auto my-0 bg-slate-800 md:max-w-6xl lg:max-w-7xl max-w-7xl ">
    <main className="relative min-h-[calc(100vh)] mx-auto my-0 bg-slate-800 transition ease-linear transform md:max-w-4xl lg:max-w-6xl xl:max-w-7xl ">
      <Header />
      <div className="grid grid-cols-[auto_1fr] ">
        <Routes>
          <Route
            path="/"
            element={
              <SideBar
                onClickHome={homeStyleHandler}
                onClickOther={otherStyleHandler}
              />
            }
          >
            <Route index element={<Home homeElement={headerStyle} />} />
            <Route
              path="project"
              element={<Project homeElement={headerStyle} />}
            />
            <Route
              path="skills"
              element={<Skills homeElement={headerStyle} />}
            />

            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </div>
    </main>
  );
};

export default App;
